import React from 'react';

import VistaprintWidgetUtil from 'utils/VistaprintWidgetUtil';

// this component hides the ugliness of working with window.vp.widget for our loader by exposing a normal, reacty interface
export default function LoadingBox(props) {
    const {
        show,
        text,
    } = props;

    if (show && !VistaprintWidgetUtil.loadingBoxShown) {
        VistaprintWidgetUtil.showLoadingBox(text);
    } else if (!show && VistaprintWidgetUtil.loadingBoxShown) {
        VistaprintWidgetUtil.hideLoadingBox();
    }

    return (<div></div>);
}


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/LoadingBox.js